// @ts-expect-error: implicitly has an 'any' type
import buildLocalizeFn from 'date-fns/locale/_lib/buildLocalizeFn';
import enUsLocale from 'date-fns/locale/en-US';

const defaultMonthValues = [
  'Janaayo',
  'Febaraayo',
  'Maarso',
  'Abriil',
  'Maayo',
  'Juun',
  'Luuliyo',
  'Agoosto',
  'Sibteembar',
  'Oktoobar',
  'Nufeembar',
  'Diseembar',
];

const monthValues = {
  narrow: defaultMonthValues,
  abbreviated: defaultMonthValues,
  wide: defaultMonthValues,
};

const defaultDayValues = ['Axad', 'Isniin', 'Talaado', 'Arbaco', 'Khamiis', 'Jimce', 'Sabti']; // Sunday first

const dayValues = {
  narrow: defaultDayValues,
  short: defaultDayValues,
  abbreviated: defaultDayValues,
  wide: defaultDayValues,
};

const defaultDayPeriodValues = {
  am: 'galinka hore',
  pm: 'galinka danbe',
  midnight: 'saqdhexe',
  noon: 'duhurkii',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night',
};

const dayPeriodValues = {
  narrow: defaultDayPeriodValues,
  abbreviated: defaultDayPeriodValues,
  wide: defaultDayPeriodValues,
};

const defaultFormattingDayPeriodValues = {
  am: 'galinka hore',
  pm: 'galinka danbe',
  midnight: 'saqdhexe',
  noon: 'duhurkii',
  morning: 'in the morning',
  afternoon: 'in the afternoon',
  evening: 'in the evening',
  night: 'at night',
};

const formattingDayPeriodValues = {
  narrow: defaultFormattingDayPeriodValues,
  abbreviated: defaultFormattingDayPeriodValues,
  wide: defaultFormattingDayPeriodValues,
};

export const localize: Locale['localize'] = {
  ordinalNumber: enUsLocale.localize!.ordinalNumber,
  era: enUsLocale.localize!.era,
  quarter: enUsLocale.localize!.quarter,
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide',
  }),
};
